export const jobKeys = {
	all: ['leadJobs'],
	byProspectQuery: (prospectQueryId) => ['leadJobs', 'byProspectQuery', prospectQueryId],
	progress: (queueName, jobId) => ['leadJobs', 'progress', queueName, jobId],
};
